// Словарь маркеров с русскими названиями и типами
export const markersDictionary = {
  // Основные данные
  'time_stamp': { label: 'Временная метка', isNumeric: false, isHidden: true, isSystem: true },
  'session_id': { label: 'ID сессии', isNumeric: false, isHidden: true, isSystem: true },
  'type': { label: 'Тип', isNumeric: false, isHidden: true },
  'group_id': { label: 'Группа', isNumeric: false, isHidden: true },
  'post_id': { label: 'ID поста', isNumeric: false, isHidden: true },
  'comment_id': { label: 'ID комментария', isNumeric: false, isHidden: true },
  'author_id': { label: 'ID автора', isNumeric: false, isHidden: true },
  'date': { label: 'Дата', isNumeric: false, isHidden: true },
  'text': { label: 'Текст', isNumeric: false },
  'text_cleaned': { label: 'Очищенный текст', isNumeric: false },
  'has_text': { label: 'Есть текст', isNumeric: false, isHidden: true, isSystem: true },

  // Статистика текста
  'char_count': { label: 'Количество символов', isNumeric: true },
  'word_count': { label: 'Количество слов', isNumeric: true },
  'sentence_count': { label: 'Количество предложений', isNumeric: true },
  'unique_words_count': { label: 'Уникальные слова', isNumeric: true },
  'punctuation_count': { label: 'Знаки препинания', isNumeric: true },
  'punctuation_per_word': { label: 'Знаков на слово', isNumeric: true },
  'uppercase_rate': { label: 'Доля заглавных', isNumeric: true },
  'mean_word_len': { label: 'Средняя длина слова', isNumeric: true },
  'mean_sentence_len': { label: 'Средняя длина предложения', isNumeric: true },
  'unique_words_rate': { label: 'Доля уникальных слов', isNumeric: true },

  // Глаголы
  'verbs_1p_rate': { label: 'Глаголы 1-го лица', isNumeric: true },
  'verbs_2p_rate': { label: 'Глаголы 2-го лица', isNumeric: true },
  'verbs_3p_rate': { label: 'Глаголы 3-го лица', isNumeric: true },
  'verbs_past_tense_rate': { label: 'Прошедшее время', isNumeric: true },
  'infinitives_rate': { label: 'Инфинитивы', isNumeric: true },
  'gerunds': { label: 'Герундии', isNumeric: true },
  'participles': { label: 'Причастия', isNumeric: true },

  // Местоимения
  'pro_1p_rate': { label: 'Местоимения 1-го лица', isNumeric: true },
  'pro_1p_sing_rate': { label: 'Мест. 1-го лица (ед. ч.)', isNumeric: true },
  'pro_1p_plural_rate': { label: 'Мест. 1-го лица (мн. ч.)', isNumeric: true },
  'pro_2p_rate': { label: 'Местоимения 2-го лица', isNumeric: true },
  'pro_3p_rate': { label: 'Местоимения 3-го лица', isNumeric: true },

  // Коэффициенты
  'trager_coef': { label: 'Коэф. Трейгера', isNumeric: true },
  'logical_coh_coef': { label: 'Логическая связность', isNumeric: true },
  'verbs_per_nouns_coef': { label: 'Глаголы/сущ.', isNumeric: true },
  'participles_gerunds_coef': { label: 'Прич./герунд.', isNumeric: true },
  'negation_rate': { label: 'Доля отрицаний', isNumeric: true },

  // Части речи (POSTAG)
  'postag_A': { label: 'Прилагательные', isNumeric: true },
  'postag_ADV': { label: 'Наречия', isNumeric: true },
  'postag_ADVPRO': { label: 'Местоименные наречия', isNumeric: true },
  'postag_ANUM': { label: 'Колич. числительные', isNumeric: true },
  'postag_APRO': { label: 'Местоименные прил.', isNumeric: true },
  'postag_COM': { label: 'Составные слова', isNumeric: true },
  'postag_CONJ': { label: 'Союзы', isNumeric: true },
  'postag_INTJ': { label: 'Междометия', isNumeric: true },
  'postag_NUM': { label: 'Числительные', isNumeric: true },
  'postag_PART': { label: 'Частицы', isNumeric: true },
  'postag_PR': { label: 'Предлоги', isNumeric: true },
  'postag_S': { label: 'Существительные', isNumeric: true },
  'postag_SPRO': { label: 'Местоименные сущ.', isNumeric: true },
  'postag_V': { label: 'Глаголы', isNumeric: true },

  // Тематические группы (TGW)
  'tgw_positive_assessment': { label: 'Позитивная оценка', isNumeric: true },
  'tgw_positive_social': { label: 'Позитивное соц.', isNumeric: true },
  'tgw_positive_emotions': { label: 'Позитивные эмоции', isNumeric: true },
  'tgw_negative_assessment': { label: 'Негативная оценка', isNumeric: true },
  'tgw_negative_social': { label: 'Негативное соц.', isNumeric: true },
  'tgw_negative_emotions': { label: 'Негативные эмоции', isNumeric: true },
  'tgw_motivation_activity': { label: 'Мотивация', isNumeric: true },
  'tgw_cognitive_communication': { label: 'Когнитивная связь', isNumeric: true },
  'tgw_destructive_activity': { label: 'Деструктивность', isNumeric: true },
  'tgw_affect_lex': { label: 'Аффективная лексика', isNumeric: true },
  'tgw_bodily_states_emotions': { label: 'Телесные эмоции', isNumeric: true },
  'tgw_invectives': { label: 'Инвективы', isNumeric: true },
  'tgw_soft_invectives': { label: 'Мягкие инвективы', isNumeric: true },
  'tgw_obscene_lex': { label: 'Нецензурная лексика', isNumeric: true },
  'tgw_youth_jargon': { label: 'Молодёжный жаргон', isNumeric: true },
  'tgw_hcs': { label: 'Человеческие связи', isNumeric: true },
  'tgw_economics': { label: 'Экономика', isNumeric: true },
  'tgw_catastrophes': { label: 'Катастрофы', isNumeric: true },
  'tgw_security_structures': { label: 'Силовые структуры', isNumeric: true }, 
  'tgw_healthcare_demography_ecology': { label: 'Здравоохранение', isNumeric: true },
  'tgw_authority': { label: 'Авторитет', isNumeric: true },

  // Эмоции (BE)
  'be_disgust': { label: 'Отвращение', isNumeric: true },
  'be_shame': { label: 'Стыд', isNumeric: true },
  'be_anger': { label: 'Гнев', isNumeric: true },
  'be_fear': { label: 'Страх', isNumeric: true },
  'be_sadness': { label: 'Грусть', isNumeric: true },
  'be_calm_excitement': { label: 'Спокойствие/волнение', isNumeric: true },
  'be_happyness': { label: 'Счастье', isNumeric: true },
  'be_wonder': { label: 'Удивление', isNumeric: true },

  // Эмоции (EW)
  'ew_positive': { label: 'Позитивные эмоции (EW)', isNumeric: true },
  'ew_negative': { label: 'Негативные эмоции (EW)', isNumeric: true },
  'ew_ambivalent': { label: 'Амбивалентные эмоции', isNumeric: true },
  'ew_de_emotives': { label: 'Деэмотивы', isNumeric: true },

  // Оценка настроения
  'sentiment_rate': { label: 'Оценка настроения', isNumeric: true },
};

// Функция для получения русского названия маркера
export const getMarkerLabel = (markerKey) => {
  const marker = markersDictionary[markerKey];
  return marker ? marker.label : markerKey;
};

// Функция для проверки, является ли маркер числовым
export const isNumericMarker = (markerKey) => {
  const marker = markersDictionary[markerKey];
  return marker ? marker.isNumeric : false;
};

export const isMarkerHidden = (markerKey) => {
  const marker = markersDictionary[markerKey];
  return marker ? marker.isHidden : false;
};

export const isMarkerSystem = (markerKey) => {
  const marker = markersDictionary[markerKey];
  return marker ? marker.isSystem : false;
};

// Категории маркеров
export const markerCategories = [
  {
    category: 'Общие',
    markers: ['time_stamp', 'session_id', 'type', 'group_id', 'post_id', 'comment_id', 'author_id', 'date', 'text', 'text_cleaned', 'has_text']
  },
  {
    category: 'Статистика текста',
    markers: ['char_count', 'word_count', 'sentence_count', 'unique_words_count', 'punctuation_count', 'punctuation_per_word', 'uppercase_rate', 'mean_word_len', 'mean_sentence_len', 'unique_words_rate']
  },
  {
    category: 'Глаголы',
    markers: ['verbs_1p_rate', 'verbs_2p_rate', 'verbs_3p_rate', 'verbs_past_tense_rate', 'infinitives_rate', 'gerunds', 'participles']
  },
  {
    category: 'Местоимения',
    markers: ['pro_1p_rate', 'pro_1p_sing_rate', 'pro_1p_plural_rate', 'pro_2p_rate', 'pro_3p_rate']
  },
  {
    category: 'Коэффициенты',
    markers: ['trager_coef', 'logical_coh_coef', 'verbs_per_nouns_coef', 'participles_gerunds_coef', 'negation_rate']
  },
  {
    category: 'Части речи (POSTAG)',
    markers: ['postag_A', 'postag_ADV', 'postag_ADVPRO', 'postag_ANUM', 'postag_APRO', 'postag_COM', 'postag_CONJ', 'postag_INTJ', 'postag_NUM', 'postag_PART', 'postag_PR', 'postag_S', 'postag_SPRO', 'postag_V']
  },
  {
    category: 'Тематические группы (TGW)',
    markers: ['tgw_positive_assessment', 'tgw_positive_social', 'tgw_positive_emotions', 'tgw_negative_assessment', 'tgw_negative_social', 'tgw_negative_emotions', 'tgw_motivation_activity', 'tgw_cognitive_communication', 'tgw_destructive_activity', 'tgw_affect_lex', 'tgw_bodily_states_emotions', 'tgw_invectives', 'tgw_soft_invectives', 'tgw_obscene_lex', 'tgw_youth_jargon', 'tgw_hcs', 'tgw_economics', 'tgw_catastrophes', 'tgw_security_structures', 'tgw_healthcare_demography_ecology', 'tgw_authority']
  },
  {
    category: 'Эмоции (BE)',
    markers: ['be_disgust', 'be_shame', 'be_anger', 'be_fear', 'be_sadness', 'be_calm_excitement', 'be_happyness', 'be_wonder']
  },
  {
    category: 'Эмоции (EW)',
    markers: ['ew_positive', 'ew_negative', 'ew_ambivalent', 'ew_de_emotives']
  },
  {
    category: 'Оценка настроения',
    markers: ['sentiment_rate']
  }
];
